import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Checkbox,
  Dropdown,
  Grid,
  Icon,
  Input,
  Label,
  Message,
  Modal,
  Segment,
} from 'semantic-ui-react';

import { required, numericRange } from '@mhub/web-validations';
import { flashErrorMessage } from '../../actions/flash';
import { UNIT_STATUSES_EXTERNAL_ALL } from '../../constants/unitStatuses';
import AppForm from '../../components/AppForm';
import SpecificationTable from '../../components/SpecificationTable';
import SelectBank from '../../components/AppForm/SelectBank';
import MultiUnitPackagePricing from './MultiUnitPackagePricing';

export default class MultiUnitEdit extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    onDeselectUnit: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    projectUnitLayouts: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    packagePricings: PropTypes.oneOfType([
      PropTypes.array.isRequired,
    ]).isRequired,
    selectedRowsData: PropTypes.oneOfType([
      PropTypes.array.isRequired,
    ]).isRequired,
    allowEditUnitPrice: PropTypes.bool.isRequired,
    allowEditUnitDetails: PropTypes.bool.isRequired,
    sellingPriceCustomName: PropTypes.string,
    vaIsEnabled: PropTypes.bool,
    countryCode: PropTypes.string,
  }
  constructor(props) {
    super(props);
    const { allowEditUnitPrice, allowEditUnitDetails, sellingPriceCustomName, vaIsEnabled } = props;
    let editOptions = [];
    if (allowEditUnitDetails) {
      editOptions.push(
        { text: 'Layout Type', value: 'projectUnitLayoutID' },
        { text: 'Status', value: 'statusID' },
        { text: 'Size', value: 'size' },
      );
    }
    if (allowEditUnitPrice) {
      editOptions.push({
        text: sellingPriceCustomName || 'Selling Price',
        value: 'spaAmount',
      });
    }
    if (allowEditUnitDetails) {
      editOptions.push(
        { text: 'Bumiputra', value: 'isBumi' },
        { text: 'Address', value: 'address' },
        { text: 'Position', value: 'position' },
        { text: 'Level/Street Number', value: 'streetNumberOrLevel' },
        { text: 'Block/Zone', value: 'zoneOrBlock' },
        { text: 'Facing/Street', value: 'streetOrFacing' },
        { text: 'Public Notes', value: 'remarkExternal' },
        { text: 'Internal Notes', value: 'remarkInternal' },
      );
    }
    if (allowEditUnitPrice) {
      editOptions.push({ text: 'Pricing Package', value: 'projectUnitPackagePricings' });
    }
    if (allowEditUnitDetails) {
      editOptions.push({ text: 'Specifications', value: 'specifications' });
    }
    if (vaIsEnabled) {
      editOptions = editOptions.concat([
        { text: 'VA Bank Name', value: 'vaBankName' },
        { text: 'VA Account Number', value: 'vaAccountNumber' },
      ]);
    }
    const errors = {
      size: '',
      spaAmount: '',
      position: '',
    };
    this.state = {
      editOptions,
      errors,
      fieldValue: '',
      messageText: '',
      selectedEditField: '',
      showMessage: false,
      spaType: 'manual',
      vErrMessages: [],
      sellingPriceCustomName,
    };
    this.validation = {
      spaAmount: createRef(),
      size: createRef(),
      position: createRef(),
    };
  }
  componentWillReceiveProps(nextProps) {
    const { allowEditUnitPrice, allowEditUnitDetails, sellingPriceCustomName, vaIsEnabled } = nextProps;
    if (
      allowEditUnitDetails !== this.props.allowEditUnitDetails ||
      allowEditUnitPrice !== this.props.allowEditUnitPrice ||
      vaIsEnabled !== this.props.vaIsEnabled
    ) {
      let editOptions = [];
      if (allowEditUnitDetails) {
        editOptions.push(
          { text: 'Layout Type', value: 'projectUnitLayoutID' },
          { text: 'Status', value: 'statusID' },
          { text: 'Size', value: 'size' },
        );
      }
      if (allowEditUnitPrice) {
        editOptions.push({
          text: sellingPriceCustomName || 'Selling Price',
          value: 'spaAmount',
        });
      }
      if (allowEditUnitDetails) {
        editOptions.push(
          { text: 'Bumiputra', value: 'isBumi' },
          { text: 'Address', value: 'address' },
          { text: 'Position', value: 'position' },
          { text: 'Level/Street Number', value: 'streetNumberOrLevel' },
          { text: 'Block/Zone', value: 'zoneOrBlock' },
          { text: 'Facing/Street', value: 'streetOrFacing' },
          { text: 'Public Notes', value: 'remarkExternal' },
          { text: 'Internal Notes', value: 'remarkInternal' },
        );
      }
      if (allowEditUnitPrice) {
        editOptions.push({ text: 'Pricing Package', value: 'projectUnitPackagePricings' });
      }
      if (allowEditUnitDetails) {
        editOptions.push({ text: 'Specifications', value: 'specifications' });
      }
      if (vaIsEnabled) {
        editOptions = editOptions.concat([
          { text: 'VA Bank Name', value: 'vaBankName' },
          { text: 'VA Account Number', value: 'vaAccountNumber' },
        ]);
      }
      this.setState({ editOptions, sellingPriceCustomName });
    }
  }
  getSPAValueLabel = () => {
    if (this.state.spaType === 'deduct') {
      return '- %';
    }
    if (this.state.spaType === 'increase') {
      return '+ %';
    }
    return '$';
  }
  getChangedSPAValues = (selectedRowsData) => {
    const { fieldValue, spaType } = this.state;
    const groupedArray = [];
    const finalArray = [];
    selectedRowsData.filter(
      d => d.isSelected).forEach(d => groupedArray.push(parseFloat(d.spaAmount)),
    );
    groupedArray.filter((item, id) => groupedArray.indexOf(item) === id).forEach((d) => {
      finalArray.push({
        before: d,
        after: this.getAfterSPAValue(d, fieldValue, spaType),
      });
    });
    return finalArray;
  }
  getSPAValueFormula = () => {
    const { spaType } = this.state;
    if (spaType === 'increase') {
      return 'round(SPA_VALUE + (PERCENT_VALUE ÷ 100) x SPA_VALUE))';
    }
    if (spaType === 'deduct') {
      return 'round(SPA_VALUE - (PERCENT_VALUE ÷ 100) x SPA_VALUE))';
    }
    return '';
  }
  getSPAValuePlaceholder = () => {
    if (this.state.spaType === 'manual') {
      return this.state.sellingPriceCustomName || 'Selling Price';
    }
    return 'Price Percentage';
  }
  getValueName = (value, arr) => {
    const valueName = arr.find(vn => vn.value === value);
    if (valueName && valueName.text) {
      return valueName.text;
    }
    return '';
  }
  getAfterSPAValue = (value, percent, type) => {
    if (type === 'increase') {
      return Math.round(value + ((percent / 100) * value));
    }
    if (type === 'deduct') {
      return Math.round(value - ((percent / 100) * value));
    }
    return this.state.fieldValue;
  }
  spaTypeOptions = [
    { text: 'Fixed Value', value: 'manual' },
    // { text: 'Deduct by Percent', value: 'deduct' },
    // { text: 'Increase by Percent', value: 'increase' },
  ];
  checkConfirmIsDisabled = () => {
    const { errors, fieldValue } = this.state;
    if (errors.size !== '' || errors.spaAmount !== '' || errors.position !== '') {
      return true;
    }
    if (!fieldValue) {
      return true;
    }
    return false;
  }
  handleSPATypeChange = (e, data) => {
    this.setState({ spaType: data.value }, () => {
      this.validation.spaAmount.current.validate(this.state.fieldValue);
    });
  }
  handleCheckboxChange = () => {
    this.setState({ fieldValue: !this.state.fieldValue });
  }
  handleDismissMessage = () => {
    this.setState({ showMessage: false });
  }
  handleInputChange = (e, data) => {
    if (
      data.name === 'size' ||
      data.name === 'spaAmount' ||
      data.name === 'position'
    ) {
      this.validation[data.name].current.validate(data.value);
    }
    this.setState({ fieldValue: data.value });
  }
  handleOnClose = (e) => {
    e.preventDefault();
    if (this.props.onClose) {
      this.props.onClose();
    }
    this.setState({
      selectedEditField: '',
      fieldValue: '',
      messageText: '',
      showMessage: false,
      spaType: 'manual',
    });
  }
  handleOnDeselectUnit = (e, rowID) => {
    e.preventDefault();
    const { selectedRowsData } = this.props;
    const row = selectedRowsData.find(r => r.rowID === rowID);
    const messageText = `Successfully deselected unit ${row.reference}`;
    if (this.props.onDeselectUnit) {
      this.props.onDeselectUnit(e, rowID);
    }
    this.setState({ messageText, showMessage: true });
  }
  handleOnSave = async (e, closeModal) => {
    const { store } = this.context;
    e.preventDefault();
    const { selectedEditField, fieldValue, editOptions, vErrMessages } = this.state;
    if (vErrMessages.length > 0) {
      await store.dispatch(flashErrorMessage({ header: 'Please fix form errors', list: vErrMessages.map(l => l.message) }));
      return;
    }
    let showMessage = false;
    let messageText = '';
    if (this.props.onSave) {
      if (selectedEditField === 'spaAmount' && fieldValue !== '') {
        this.props.onSave(closeModal, 'spaAmount', {
          type: this.state.spaType,
          value: fieldValue,
        });
      } else {
        this.props.onSave(closeModal, selectedEditField, fieldValue);
      }
    }
    if (!closeModal && selectedEditField !== '' && fieldValue !== '') {
      messageText = `Successfully set ${this.getValueName(selectedEditField, editOptions).toLowerCase()} for selected units`;
      showMessage = true;
    }
    this.setState({
      fieldValue: '',
      selectedEditField: '',
      messageText,
      showMessage,
      spaType: 'manual',
    });
  }
  handleSelectedFieldChange = (e, data) => {
    const errors = {
      size: '',
      spaAmount: '',
      position: '',
    };
    let fieldValue = '';
    if (data.value === 'isBumi') {
      fieldValue = false;
    }
    if (data.value === 'specifications') {
      fieldValue = [];
    }
    if (data.value === 'projectUnitPackagePricings') {
      fieldValue = [];
    }
    this.setState({ errors, selectedEditField: data.value, fieldValue });
  }
  handleDataChange = (data, vErrMessages = '') => {
    this.setState({ fieldValue: data, vErrMessages });
  }
  handleTextAreaChange = (e) => {
    this.setState({ fieldValue: e.target.value });
  }
  handleOnError = (hasError, errorMessage, inputName) => {
    const { errors } = this.state;
    errors[inputName] = errorMessage;
    if (hasError) {
      errors[inputName] = errorMessage;
    } else {
      errors[inputName] = '';
    }
    this.setState({ errors });
  }
  render() {
    const {
      errors,
      fieldValue,
      messageText,
      selectedEditField,
      showMessage,
      spaType,
      editOptions,
      sellingPriceCustomName,
    } = this.state;
    const { countryCode, selectedRowsData } = this.props;
    return (
      <Modal
        closeIcon
        closeOnEscape={false}
        closeOnDimmerClick={false}
        onClose={this.handleOnClose}
        open={this.props.open === true}
      >
        <Modal.Header>Multi Edit</Modal.Header>
        <Modal.Content>
          <Grid>
            <Grid.Row >
              <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                <b>Choose field to edit:</b>
              </Grid.Column>
              <Grid.Column width={13}>
                <Dropdown
                  placeholder="Select field"
                  fluid
                  selection
                  options={editOptions}
                  selectOnBlur={false}
                  search
                  onChange={this.handleSelectedFieldChange}
                  value={selectedEditField}
                />
              </Grid.Column>
            </Grid.Row>
            { selectedEditField !== '' &&
              <Grid.Row >
                <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                  <b>Set value to:</b>
                </Grid.Column>
                <Grid.Column width={13}>
                  {
                    (selectedEditField === 'projectUnitLayoutID') && (
                      <Dropdown
                        placeholder="Select layout type"
                        fluid
                        selection
                        options={this.props.projectUnitLayouts}
                        selectOnBlur={false}
                        onChange={this.handleInputChange}
                      />
                    )
                  }
                  {
                    (selectedEditField === 'statusID') && (
                      <Dropdown
                        placeholder="Select status"
                        fluid
                        selection
                        options={UNIT_STATUSES_EXTERNAL_ALL}
                        selectOnBlur={false}
                        onChange={this.handleInputChange}
                      />
                    )
                  }
                  {
                    (selectedEditField === 'isBumi') && (
                      <Checkbox
                        label="Bumiputra Unit"
                        checked={fieldValue}
                        onChange={this.handleCheckboxChange}
                      />
                    )
                  }
                  {
                    (selectedEditField === 'size' ||
                      selectedEditField === 'position'
                    ) && (
                      <AppForm.Validate
                        hideMessage
                        onChange={this.handleInputChange}
                        onError={
                          (hasError, msg) => this.handleOnError(hasError, msg, selectedEditField)
                        }
                        ref={this.validation[selectedEditField]}
                        validateLabel={`${selectedEditField === 'size' ? 'Size' : ''}${selectedEditField === 'position' ? 'Position' : ''}`}
                        validation={selectedEditField === 'size' ? [required, {
                          validate: numericRange,
                          option: {
                            min: 0,
                            max: 2147483647,
                          },
                        }] : [required, {
                          validate: numericRange,
                          option: {
                            min: 1,
                            max: 2147483647,
                          },
                        }]}
                      >
                        <Input
                          fluid
                          name={selectedEditField}
                          ref={(ref) => { this[selectedEditField] = ref; }}
                          type="number"
                          value={fieldValue}
                          min={selectedEditField === 'size' ? '0' : '1'}
                          step="0.0001"
                        />
                      </AppForm.Validate>
                    )
                  }
                  {
                    (selectedEditField === 'streetNumberOrLevel' ||
                      selectedEditField === 'zoneOrBlock' ||
                      selectedEditField === 'streetOrFacing' ||
                      selectedEditField === 'vaAccountNumber'
                    ) && (
                      <Input
                        fluid
                        value={fieldValue}
                        onChange={this.handleInputChange}
                      />
                    )
                  }
                  {
                    selectedEditField === 'spaAmount' &&
                      <AppForm.Validate
                        hideMessage
                        onChange={this.handleInputChange}
                        onError={
                          (hasError, msg) => this.handleOnError(hasError, msg, selectedEditField)
                        }
                        ref={this.validation.spaAmount}
                        validateLabel={
                          spaType === 'manual'
                            ? (sellingPriceCustomName || 'Selling Price')
                            : 'Price Percentage'
                        }
                        validation={[required, {
                          validate: numericRange,
                          option: {
                            min: 0,
                            max: spaType === 'manual' ? 2147483647 : 99,
                          },
                        }]}
                      >
                        <Input
                          fluid
                          name="spaAmount"
                          labelPosition="right"
                          type="number"
                          step=".01"
                          placeholder={this.getSPAValuePlaceholder()}
                          ref={(ref) => { this.spaAmount = ref; }}
                          value={fieldValue}
                        >
                          <Label>{this.getSPAValueLabel()}</Label>
                          <input />
                          <Label basic>
                            <Dropdown
                              simple
                              options={this.spaTypeOptions}
                              value={spaType}
                              selectOnBlur={false}
                              onChange={this.handleSPATypeChange}
                            />
                          </Label>
                        </Input>
                      </AppForm.Validate>
                  }
                  { selectedEditField === 'projectUnitPackagePricings' &&
                    <MultiUnitPackagePricing
                      data={fieldValue || []}
                      onChange={this.handleDataChange}
                      packagePricings={this.props.packagePricings}
                    />
                  }
                  {
                    (selectedEditField === 'address' ||
                      selectedEditField === 'remarkInternal' ||
                      selectedEditField === 'remarkExternal'
                    ) && (
                      <textarea
                        className="semantic-textbox"
                        style={{ minHeight: '6em', maxHeight: '40vh', width: '100%' }}
                        value={fieldValue}
                        onChange={this.handleTextAreaChange}
                      />
                    )
                  }
                  {
                    (selectedEditField === 'specifications') && (
                      <SpecificationTable
                        type="units"
                        editable
                        isEditing
                        hideButton
                        data={fieldValue}
                        onChange={this.handleDataChange}
                      />
                    )
                  }
                  {
                    (selectedEditField === 'vaBankName') && (
                      <SelectBank
                        country={countryCode}
                        name="fieldValue"
                        placeholder="Select bank"
                        onChange={this.handleInputChange}
                        value={fieldValue}
                      />
                    )
                  }
                  {
                    errors[selectedEditField] !== '' &&
                    <small>{errors[selectedEditField]}</small>
                  }
                </Grid.Column>
              </Grid.Row>
            }
            <Grid.Row >
              <Grid.Column>
                { (selectedEditField === 'spaAmount' && (spaType !== 'manual' || fieldValue !== '')) ?
                  <Segment textAlign="center" inverted>
                    {
                      spaType !== 'manual' ?
                        <center>
                          <small><b>Formula:</b>&nbsp;&nbsp;{this.getSPAValueFormula()}</small>
                        </center>
                      : ''
                    }
                    <Label.Group color="blue" size="mini">
                      {
                        this.getChangedSPAValues(selectedRowsData).length > 0 && fieldValue !== '' ?
                        this.getChangedSPAValues(selectedRowsData).map((data, idx) => (
                          <Label
                            as="div"
                            key={idx}
                          >
                            {data.before}<Icon style={{ margin: '0 0.5em' }} name="arrow right" />{data.after}
                          </Label>
                        ))
                        : null
                      }
                    </Label.Group>
                  </Segment>
                  : ''
                }
                {
                  showMessage ?
                    <Message
                      onDismiss={this.handleDismissMessage}
                      success
                    >
                      <b>{messageText}</b>
                    </Message>
                  : ''
                }
                <Segment color="teal">
                  <div>
                    <Label.Group color="teal" size="mini">
                      {
                        selectedRowsData.length > 0 ?
                        selectedRowsData.map((data, idx) => (
                          <Label
                            as={selectedRowsData.length > 1 ? 'a' : 'div'}
                            key={idx}
                            onClick={e =>
                              selectedRowsData.length > 1 &&
                              this.handleOnDeselectUnit(e, data.rowID)
                            }
                            title={selectedRowsData.length > 1 ? 'Deselect unit' : ''}
                          >
                            {data.reference} {
                              selectedRowsData.length > 1 ? <Icon name="remove" style={{ marginRight: '0' }} /> : ''
                            }
                          </Label>
                        ))
                        : null
                      }
                    </Label.Group>
                  </div>
                </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button disabled={this.checkConfirmIsDisabled()} onClick={e => this.handleOnSave(e, true)} content="Apply & Close" primary />
          <Button disabled={this.checkConfirmIsDisabled()} onClick={e => this.handleOnSave(e, false)} content="Apply" />
          <Button onClick={this.handleOnClose} content="Close" />
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/modals/MultiUnitEdit.jsx